import { booleanAttribute, Directive, input } from '@angular/core';
import { classes } from '@spartan-ng/helm/utils';
import { HlmCardConfig, injectHlmCardConfig } from './hlm-card.token';

@Directive({
  selector: '[hlmCard],hlm-card',
  host: {
    'data-slot': 'card',
    '[attr.data-size]': 'size()',
    '[attr.data-interactive]': 'interactive()',
    '[attr.data-selected]': 'selected()',
  },
})
export class HlmCard {
  private readonly _defaultConfig = injectHlmCardConfig();
  public readonly size = input<HlmCardConfig['size']>(this._defaultConfig.size);
  /** Turns the card into a clickable surface (interactive background, hover + selected states). */
  public readonly interactive = input(false, { transform: booleanAttribute });
  /** Applies the selected background. Only has an effect when `interactive` is set. */
  public readonly selected = input(false, { transform: booleanAttribute });

  constructor() {
    classes(
      () =>
        'bg-card-background text-card-color gap-(--card-spacing) overflow-hidden rounded-[var(--radius-lg)] px-0 py-(--card-spacing) text-sm shadow-none transition-shadow hover:shadow-card-hover [--card-spacing:--spacing(10)] has-[>img:first-child]:pt-0 data-[size=sm]:[--card-spacing:--spacing(4)] *:[img:first-child]:rounded-t-[var(--radius-lg)] *:[img:last-child]:rounded-b-[var(--radius-lg)] group/card flex flex-col data-[interactive=true]:cursor-pointer data-[interactive=true]:duration-200 data-[interactive=true]:[--card-spacing:--spacing(2.5)] data-[interactive=true]:data-[selected=true]:bg-card-interactive-background-selected'
    );
  }
}
